export default __webpack_public_path__ + "static/media/image-solid.3dbba70b.svg";